import { render } from "./F2Action.vue?vue&type=template&id=83a6be16&scoped=true&ts=true"
import script from "./F2Action.vue?vue&type=script&lang=ts"
export * from "./F2Action.vue?vue&type=script&lang=ts"

import "./F2Action.vue?vue&type=style&index=0&id=83a6be16&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83a6be16"]])

export default __exports__